import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

interface Props {}

export const ProposalProcessing = ({}: Props) => {
  return (
    <Box
      sx={{
        gap: "1rem",
        display: "flex",
        height: "35rem",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}>
      <Typography variant="h6" component="span">
        Processing proposal
      </Typography>

      <CircularProgress />
    </Box>
  );
};
